import { Popup } from "./popup";

export class FeaturedVideoPopup {
	constructor(options = {}) {
		this._featuredVideoPopupClass = options.bindTo;
		this._popup = Popup.setup({
			selector: options.popupTarget
		});
		this.bindClickToVideoThumb(options.videoThumbnail);
		this.bindClickToVideoPopupCloseBtn(options.videoPopupCloseBtn);
	}
	static setup(options = {}) {
        new FeaturedVideoPopup(options)
    }

	bindClickToVideoThumb(target) {
		jQuery(document).on('click', target, (event) => {
			//jQuery('body').addClass("video-popup-open");
			this._popup.Show();
			//start the video
			jQuery('#popup-youtube-player')[0].contentWindow.postMessage('{"event":"command","func":"' + 'playVideo' + '","args":""}', '*'); 
			return false
		})
	}
	bindClickToVideoPopupCloseBtn(target) {
		jQuery(document).on('click', target, (event) => {
			this._popup.Hide();
			//stop the video
			jQuery('#popup-youtube-player')[0].contentWindow.postMessage('{"event":"command","func":"' + 'stopVideo' + '","args":""}', '*');
			//jQuery('body').removeClass("video-popup-open");
			return false
		})
	}
}